module.exports = __webpack_public_path__ + "media/images/gallery/constellations/virgo/vir_vis-db94b6a9ad6bab3e772f8558c81e3191.jpg";